import { IconElement, PopoverMenuProps } from '@wix/design-system';

export type MultiBulkActionSubItem = {
  /**
   * An event for button click.
   */
  onClick?: any;
  /*
   * Button text.
   */
  text?: string;
  /*
   * An optional Icon prefix.
   */
  prefixIcon?: IconElement;
  /*
   * An optional tooltip text.
   */
  tooltipText?: string;
  /*
   * An optional disabled flag.
   * */
  disabled?: boolean;
  /*
   *  A data-hook for the button.
   */
  dataHook?: string;
  /*
   * A unique name for CTAClick bi event. For example: 'edit'.
   */
  biName?: string;
  /*
   * Array of action items to be rendered in a popover menu.
   */
  subItems?: MultiBulkActionSubItem[];
  /*
   * Custom [PopoverMenuProps](https://www.docs.wixdesignsystem.com/?path=/story/components-overlays--popovermenu) to pass to the sub-items popover menu
   */
  popoverMenuProps?: Partial<PopoverMenuProps>;
};

export type MultiBulkActionSubItemPrivate = Omit<
  MultiBulkActionSubItem,
  'subItems'
> & {
  biIndex: number;
  subItems?: (MultiBulkActionSubItem & {
    componentId?: string;
    appId?: string;
  })[];
};
